import {
    AppBar, IconButton, NativeSelect, Toolbar, Typography,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { useEffect, useState } from "react";
import api from "../../api";

import useStore from "../../store";

export default function Selection() {
    const [isLoading, setIsLoading] = useState(true);
    const [dashboards, setDashboards] = useState([]);
    const [selectedDashboardId, setSelectedDashboardId] = useState(null);

    const setDashboardSelectionOpen = useStore((store) => store.dashboard.setDashboardSelectionOpen);
    const changeDashboard = useStore((store) => store.dashboard.change);
    const read = async () => {
        setIsLoading(true);

        const { data } = await api.dashboard.read();

        setIsLoading(false);
        return data;
    };

    const handleSelectOnChange = (event) => {
        setSelectedDashboardId(event.target.value);
    };

    useEffect(() => {
        let unmounted = false;
        (async () => {
            const dbDashboards = await read();

            if (!unmounted) {
                setDashboards(dbDashboards);
            }
        })();

        return () => {
            unmounted = true;
        };
    }, []);

    useEffect(() => {
        changeDashboard(selectedDashboardId);
    }, [selectedDashboardId]);

    return (
        <div style={{
            display: "grid",
            alignItems: "center",
            justifyContent: "center",
            height: 25,
        }}
        >
            <AppBar
                position="static"
                sx={{
                    paddingLeft: 5,
                    paddingRight: 5,
                    borderBottomLeftRadius: 5,
                    borderBottomRightRadius: 5,
                }}
            >
                <Toolbar>
                    <Typography>
                        <FontAwesomeIcon icon="tachometer-alt" />
                        {" "}
                        Dashboardauswahl:
                        {isLoading
                            ? (
                                <FontAwesomeIcon
                                    mt={6}
                                    ml={2}
                                    mr={2}
                                    icon="spinner"
                                    spin
                                />
                            )
                            : null}
                    </Typography>
                    <NativeSelect value={selectedDashboardId} onChange={handleSelectOnChange}>
                        {dashboards.map((dashboard) => (
                            <option key={dashboard.id} value={dashboard.id}>
                                {dashboard.username}
                                {" "}
                                -
                                {" "}
                                {dashboard.name}
                            </option>
                        ))}
                    </NativeSelect>
                    <IconButton color="inherit" onClick={() => setDashboardSelectionOpen(false)}>
                        <FontAwesomeIcon icon="times" />
                    </IconButton>
                </Toolbar>
            </AppBar>
        </div>
    );
}
